import React, { Component } from 'react';
import { Button, Select, message, DatePicker, Icon } from 'antd';
import HighSearchInput from '../../common/HighSearchInput';
import SearchMulSelect from '../../common/SearchMulSelect';
import SelectProvince from '../../common/SelectProvince';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import moment from 'moment';
import fp from '../../../utils/fp';
import SearchRetrieve from '../../common/SearchRetrieve.new';

const Option = Select.Option;
const dateFormat = 'YYYY-MM-DD';

class Filter extends Component {
    state = {
        areaList: [],
        diseaseList: [],
        searchParams: {},
        userOptions: [],
        managerOptions: [],
        hospitalOptions: [],
        businessList: [],
        investigationOptions: [],
        expand: false,
        render: true,
        CourtyardAreaList: [],
        needCourtyardArea: false, //院区必填判断
        // 固化数据年月列表
        yearMonthList: [],
        cooperationDegreeOptions: [],
    }

    componentDidMount() {
        this.loadAreaList();
        this.queryWithLevelByParams();
        this.loadYearMonthList();
        this.loadCooperationDegreeOptions();
        const { params } = this.props;
        this.setState({
            searchParams:{
                ...params
            }
        })
    }

    /**
     * 查询已固化的年月列表，默认选中当前年月
     */
    loadYearMonthList = () => {
        $.sendRequest({
            method: 'POST',
            url: API_URL.hospital.queryHospitalDataRecordYearMonth,
            data: {},
            dataType: 'json',
            doneResult: res => {
                if (res && res.yearMonthList) {
                    const now = moment();
                    const curYearMonth = parseInt(now.format('YYYYMM'));
                    const list = res.yearMonthList || [];
                    if (list.indexOf(curYearMonth) === -1) {
                        list.unshift(curYearMonth);
                    }
                    this.setState(prevState => ({
                        yearMonthList: list,
                        searchParams: {
                            ...prevState.searchParams,
                            date: now.format('YYYY-MM'),
                        },
                    }));
                }
            },
        });
    }

    /**
     * 加载紧密合作程度选项（从配置表查询）
     */
    loadCooperationDegreeOptions = () => {
        $.sendRequest({
            method: 'POST',
            url: API_URL.hospital.queryHospitalConfigureList,
            data: { type: 'COOPERATION_DEGREE' },
            dataType: 'json',
            doneResult: res => {
                if (res && res.list) {
                    this.setState({ cooperationDegreeOptions: res.list });
                }
            },
        });
    }

    search = () => {
        const { searchParams, userOptions, managerOptions, investigationOptions } = this.state;
        const { areaParams, hasCheckedArea, actualEnd, actualStart, planStart, planEnd, userId, directorUserId, investigationId, courtyardArea, ...rest } = searchParams;
        // if (investigationId) {
        //     const isExist = investigationOptions.some(item => item.value == investigationId);
        //     if (!isExist) {
        //         message.warning('请选择正确的项目简称');
        //         return;
        //     }
        // }
        if (actualEnd && (!actualStart)) {
            message.warning('请选择实际上会开始时间');
            return;
        }
        if (actualStart && (!actualEnd)) {
            message.warning('请选择实际上会结束时间');
            return;
        }
        if (planStart && (!planEnd)) {
            message.warning('请选择计划上会结束时间');
            return;
        }
        if (planEnd && (!planStart)) {
            message.warning('请选择计划上会开始时间');
            return;
        }
        if (userId) {
            const isExist = userOptions.some(item => item.value == userId);
            if (!isExist) {
                message.warning('请选择正确的津石负责人');
                return;
            }
        }
        // if (directorUserId) {
        //     const isExist = managerOptions.some(item => item.value == directorUserId);
        //     if (!isExist) {
        //         message.warning('请选择正确的医院主管');
        //         return;
        //     }
        // }
        this.props.search({ ...rest, ...areaParams, actualEnd, actualStart, planStart, planEnd, userId, directorUserId, investigationId, courtyardArea });
    }

    reset = () => {
        this.setState({
            render: false,
            diseaseList: [],
            searchParams: {
                date: moment().format('YYYY-MM'),
            },
            userOptions: [],
            managerOptions: [],
            hospitalOptions: [],
            investigationOptions: [],
        }, () => {
            this.setState({ render: true }, () => {
                this.search();
            });
        });
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_ALL', cb => {
            $.sendRequest({
                method: 'POST',
                url: `${API_URL.common.queryAllInvestigationArea}`,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            if (!res.error) {
                this.setState({ areaList: res.data });
            }
        });
    }

    loadDiseaseList = investigationAreaId => {
        dictCache.getDict(`DISEASE_AREA_${investigationAreaId}`, cb => {
            $.sendRequest({
                method: 'POST',
                url: `${API_URL.common.queryAllDisease}`,
                data: { investigationAreaId },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            if (!res.error) {
                this.setState({ diseaseList: res.data });
            }
        });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.state;
        const params = {};
        searchParams[field] = value;
        if (field == 'investigationAreaId') {
            params.diseaseList = [];
            searchParams.diseaseId = undefined;
        } else if (field === 'lineOfBusiness') {
            searchParams.secondLineName = undefined;
        }
        this.setState({
            ...params,
            searchParams,
        }, () => {
            if (field == 'investigationAreaId' && value) {
                this.loadDiseaseList(value);
            }
        });
    }

    parseHospitalData = res => {
        if ((res.data || res.datas) ) {
            const sourceData = res.data || res.datas;
            const data = sourceData.map(item => ({
                text: `${item.hospitalName}`,
                value: item.hospitalId,
                fetching: false,
            }));
            this.setState({ hospitalOptions: data });
        } else {
            this.setState({ hospitalOptions: [] });
        }
    }

    hospitalSelectChange = value => {
        const { searchParams} = this.state;
        searchParams.hospitalMainId = value.value;
        searchParams.hospitalMainName = value.text;
        searchParams.hospitalId = undefined;
        searchParams.courtyardArea = undefined;
        this.setState({
            searchParams:{
                ...searchParams,
            },
        },()=>{
            this.state.searchParams.hospitalMainId && this.queryCourtyardAreaList();
        });
    }

    courtyardAreaSelectChange = (value) => {
        const {searchParams} = this.state;
        searchParams.courtyardArea = value;
        this.setState({
            searchParams:{
                ...searchParams,
            },
        })
    }

    queryCourtyardAreaList = () => {
            const { searchParams } = this.state;
            const options = {
                method: 'POST',
                url: API_URL.hospital.queryHospitalCourtyardAreaList,
                data: {    
                    hospitalMainId: searchParams.hospitalMainId,
                },
                dataType: 'json',
                doneResult: res => {
                    const { datas } = res;
                    let { needCourtyardArea } = this.state;
                    needCourtyardArea = false;
                    datas.map(i=>{
                        if (i.courtyardArea) {
                            needCourtyardArea = true;
                        }
                    })
                    this.setState({ CourtyardAreaList: datas, needCourtyardArea });
                }
            };
            $.sendRequest(options);
    }

    clear = () => {
        const { searchParams } = this.state;
        searchParams.hospitalCity = '';
        searchParams.hospitalProvince = '';
        this.setState({ searchParams });
    }

    /**
     * 时间选择变更
     */
    handleMonthChange = (date, dateString) => {
        const { searchParams } = this.state;
        searchParams.date = dateString;
        this.setState({ searchParams });
    }

    /**
     * 禁用不在 yearMonthList 中的月份（仅可选择已固化年月 + 当前年月）
     */
    disabledDate = (current) => {
        if (!current) return false;
        const { yearMonthList } = this.state;
        const currentYearMonth = parseInt(current.format('YYYYMM'));
        return yearMonthList.indexOf(currentYearMonth) === -1;
    }

    handleDateChange = (date, dateString, key) => {
        const { searchParams } = this.state;
        const { planStart, planEnd, actualStart, actualEnd } = searchParams;
        if (key === 'planStart') {
            if (planEnd && moment(dateString).valueOf() > moment(planEnd).valueOf()) {
                message.warning('计划上会开始时间不能大于计划上会结束时间');
                return;
            } else {
                searchParams[key] = dateString;
            }
        } else if (key === 'planEnd') {
            if (planStart && moment(dateString).valueOf() < moment(planStart).valueOf()) {
                message.warning('计划上会结束时间不能小于计划上会开始时间');
                return;
            } else {
                searchParams[key] = dateString;
            }
        } else if (key === 'actualStart') {
            if (actualEnd && moment(dateString).valueOf() > moment(actualEnd).valueOf()) {
                message.warning('实际上会开始时间不能大于实际上会结束时间');
                return;
            } else {
                searchParams[key] = dateString;
            }
        } else if (key === 'actualEnd') {
            if (actualStart && moment(dateString).valueOf() < moment(actualStart).valueOf()) {
                message.warning('实际上会结束时间不能小于实际上会开始时间');
                return;
            } else {
                searchParams[key] = dateString;
            }
        }
        this.setState({ searchParams });
    }

    saveProvince = (checkedArea) => {
        const { searchParams } = this.state;
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);
        this.setState({
            searchParams: {
                ...searchParams,
                areaParams,
                hasCheckedArea,
                areaName: areaList.join(','),
            }
        });
    }

    handleHighSearchInputChange = (id, options, idName, optionsName) => {
        const { searchParams } = this.state;
        searchParams[idName] = id;
        this.setState({
            searchParams,
            [optionsName]: options,
        });
    }

    handleSearchChange = (option) => {
        const { searchParams } = this.state;
        searchParams.directorUserId = option.value;
        searchParams.directorUserName = option.text;
        this.setState({searchParams:{...searchParams}});
    }

    showCreateModal = () => {
        this.props.showCreateModal();
    }

    toggleHeight = () => {
        this.setState((prevState) => ({
            expand: !prevState.expand,
        }));
    }

    render() {
        const { curRole } = sessionStorage;
        const { areaList, diseaseList, searchParams, hospitalOptions, expand, render, businessList, CourtyardAreaList, needCourtyardArea, cooperationDegreeOptions } = this.state;
        const { 
            investigationAreaId, 
            diseaseId, 
            hospitalLevel,
            centerPharmacy,
            cooperationDegreeId,
            isMyResponsibleHospital, 
            cityManagerFilter,
            actualEnd, 
            actualStart, 
            planStart, 
            planEnd, 
            areaName, 
            hasCheckedArea = [], 
            isCooperation, 
            lineOfBusiness,
            hospitalMainId,
            hospitalMainName,
            courtyardArea,
            directorUserName,
        } = searchParams;
        const showExportButton = curRole !== 'CRC';
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(i => <Option key={i}>{i}</Option>);
        const areaOption = areaList.map(d => <Option key={d.investigationAreaId} value={String(d.investigationAreaId)}>{d.investigationAreaName}</Option>);
        const diseaseOption = diseaseList.map(d => <Option key={d.diseaseId} value={String(d.diseaseId)}>{d.diseaseName}</Option>);
        const CourtyardAreaOptions = CourtyardAreaList.map(i => <Option key={i.hospitalId}>{i.courtyardArea}</Option>)
        const { crcFlag } = this.props;
        const { MonthPicker } = DatePicker;
        return (
            <div style={{ marginBottom: 16 }}>
                <div className={"search-bar expand" + (expand ? " expanded" : "")}>
                    <div className="expand-box">
                        <a onClick={this.toggleHeight}>
                            {expand ? "收起" : "展开"}
                            <Icon className="expand-icon" type={expand ? "up" : "down"} />
                        </a>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">时间</label>
                        <MonthPicker
                            format={'YYYY-MM'}
                            value={searchParams.date ? moment(searchParams.date) : null}
                            allowClear={false}
                            placeholder="选择年月"
                            style={{ width: 130 }}
                            disabledDate={this.disabledDate}
                            onChange={this.handleMonthChange}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">医院官方名称</label>
                        {
                            render &&
                            <SearchRetrieve
                                keyword="hospitalName"
                                style={{ width: 200 }}
                                placeholder="输入医院名称检索"
                                value={hospitalMainName}
                                params={{ limit: 10,offset:1 }}
                                url={API_URL.hospital.queryHospitalMainList}
                                config={{ id: 'hospitalMainId', name: 'hospitalMainName'}}
                                onChange={value => this.hospitalSelectChange(value, 'hospital')}
                            />
                        }
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">院区</label>
                        <Select
                            mode='multiple'
                            filterOption={false}
                            allowClear={true}
                            onSearch={this.queryCourtyardAreaList}
                            style={{ width: 180 }}
                            placeholder="请选择"
                            disabled={ !needCourtyardArea || !hospitalMainId } //本无院区，禁止填入；本有院区，且医院信息已填，允许填入
                            value={ courtyardArea }
                            onChange={value => this.courtyardAreaSelectChange(value)}
                        >
                            {CourtyardAreaOptions}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">等级</label>
                        <Select
                            allowClear={true}
                            style={{ width: 120 }}
                            placeholder="请选择"
                            value={hospitalLevel}
                            onChange={(value) => this.handleSelectChange(value, 'hospitalLevel')}
                        >
                            <Option value="三级甲等">三级甲等</Option>
                            <Option value="三级乙等">三级乙等</Option>
                            <Option value="三级丙等">三级丙等</Option>
                            <Option value="二级甲等">二级甲等</Option>
                            <Option value="二级乙等">二级乙等</Option>
                            <Option value="二级丙等">二级丙等</Option>
                            <Option value="一级甲等">一级甲等</Option>
                            <Option value="一级乙等">一级乙等</Option>
                            <Option value="一级丙等">一级丙等</Option>
                            <Option value="其他">其他</Option>
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">有无中心药房</label>
                        <Select
                            allowClear={true}
                            style={{ width: 100 }}
                            placeholder="请选择"
                            value={centerPharmacy}
                            onChange={(value) => this.handleSelectChange(value, 'centerPharmacy')}
                        >
                            <Option value="true">有</Option>
                            <Option value="false">无</Option>
                        </Select>
                    </div>
                    {!crcFlag && <div className="search-item">
                        <label className="ui-label">紧密合作程度</label>
                        <Select
                            allowClear={true}
                            style={{ width: 120 }}
                            placeholder="请选择"
                            value={cooperationDegreeId}
                            onChange={(value) => this.handleSelectChange(value, 'cooperationDegreeId')}
                        >
                            {cooperationDegreeOptions.map(item => (
                                <Option key={item.hospitalConfigureId} value={item.hospitalConfigureId}>{item.typeValue}</Option>
                            ))}
                        </Select>
                    </div>}
                    <div className="search-item" style={{ height: 30 }}>
                        <label className="ui-label">区域/城市</label>
                        {
                            render &&
                            <SelectProvince areaName={areaName} saveProvince={this.saveProvince} hasCheckedArea={hasCheckedArea} />
                        }
                    </div>
                    {!crcFlag && <div className="search-item">
                        <label className="ui-label">项目简称</label>
                        {
                            render &&
                            <HighSearchInput
                                keyword='investigationName'
                                style={{ width: 180 }}
                                placeholder="输入项目简称或编号检索"
                                params={{limit: 20}}
                                url={API_URL.investigation.queryInvestigationByName}
                                config={{ id: 'investigationId', name: 'investigationName' }}
                                onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'investigationId', 'investigationOptions')}
                            />
                        }
                    </div>}
                    {!crcFlag && <div className="search-item">
                        <label className="ui-label">项目领域</label>
                        <Select
                            allowClear={true}
                            style={{ width: 120 }}
                            onChange={(value) => this.handleSelectChange(value, 'investigationAreaId')}
                            value={investigationAreaId}
                            placeholder="请选择"
                        >
                            {areaOption}
                        </Select>
                    </div>}
                    {!crcFlag && <div className="search-item">
                        <label className="ui-label">疾病</label>
                        <Select
                            allowClear={true}
                            style={{ width: 150 }}
                            onChange={(value) => this.handleSelectChange(value, 'diseaseId')}
                            disabled={!investigationAreaId}
                            value={diseaseId}
                            placeholder="请选择"
                        >
                            {diseaseOption}
                        </Select>
                    </div>}
                    {!crcFlag && <div className="search-item PlanDate">
                        <label htmlFor="" className="ui-label">计划上会时间</label>
                        <DatePicker
                            format={dateFormat}
                            placeholder="选择日期"
                            style={{ width: 100 }}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'planStart')}
                            value={planStart ? moment(planStart) : null}
                        />
                    </div>}
                    {!crcFlag && <div className="search-item PlanDate_marginR">
                        <label htmlFor="" className="ui-label" style={{ marginRight: "5px" }}>至</label>
                        <DatePicker
                            format={dateFormat}
                            placeholder="选择日期"
                            style={{ width: 100 }}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'planEnd')}
                            value={planEnd ? moment(planEnd) : null}
                        />
                    </div>}
                    {!crcFlag && <div className="search-item PlanDate">
                        <label htmlFor="" className="ui-label">实际上会时间</label>
                        <DatePicker
                            format={dateFormat}
                            placeholder="选择日期"
                            style={{ width: 100 }}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'actualStart')}
                            value={actualStart ? moment(actualStart) : null}
                        />
                    </div>}
                    {!crcFlag && <div className="search-item PlanDate">
                        <label htmlFor="" className="ui-label" style={{ marginRight: "5px" }}>至</label>
                        <DatePicker
                            format={dateFormat}
                            placeholder="选择日期"
                            style={{ width: 100 }}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'actualEnd')}
                            value={actualEnd ? moment(actualEnd) : null}
                        />
                    </div>}
                    {/* <div className="search-item">
                        <label className="ui-label">津石负责人</label>
                        {
                            render &&
                            <HighSearchInput
                                name='user'
                                keyword='keyword'
                                style={{ width: 140 }}
                                params={{ limit: 20 }}
                                placeholder="输入姓名/工号检索"
                                url={API_URL.team.userlist}
                                config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode' }}
                                onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'userId', 'userOptions')}
                            />
                        }
                    </div> */}
                    <div className="search-item">
                        <label className="ui-label">医院主管</label>
                        {
                            render &&
                            // <HighSearchInput
                            //     name='user'
                            //     keyword='keyword'
                            //     style={{ width: 140 }}
                            //     params={{ limit: 20 }}
                            //     placeholder="输入姓名/工号检索"
                            //     url={API_URL.team.userlist}
                            //     config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode' }}
                            //     onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'directorUserId', 'managerOptions')}
                            // />
                            <SearchRetrieve
                                keyword="keyword"
                                style={{ width: 140 }}
                                params={{ limit: 20 }}
                                placeholder="输入姓名/工号检索"
                                url={API_URL.team.userlist}
                                value={directorUserName}
                                config={{  id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                onChange={ option => this.handleSearchChange(option) }
                            />
                        }
                    </div>
                    {
                        fp.contains(curRole, ['CRCM', 'CRCC']) &&
                        <div className="search-item">
                            <label className="ui-label">是否为自己区域内的医院</label>
                            <Select
                                allowClear={true}
                                style={{ width: 80 }}
                                onChange={(value) => this.handleSelectChange(value, 'cityManagerFilter')}
                                value={cityManagerFilter}
                                placeholder="请选择"
                            >
                                <Option value="1">是</Option>
                                <Option value="0">否</Option>
                            </Select>
                        </div>
                    }
                    {!crcFlag && <div className="search-item">
                        <label className="ui-label">是否为自己负责的医院</label>
                        <Select
                            allowClear={true}
                            style={{ width: 180 }}
                            onChange={(value) => this.handleSelectChange(value, 'isMyResponsibleHospital')}
                            value={isMyResponsibleHospital}
                            placeholder="请选择"
                        >
                            <Option value="SSU_USER">作为SSU负责人负责的医院</Option>
                            {/* <Option value="CHARGE_USER">作为津石负责人负责的医院</Option> */}
                            <Option value="DIRECTOR_USER">作为医院主管负责的医院</Option>
                            <Option value="NOT_RES">不是自己负责的医院</Option>
                        </Select>
                    </div>}
                    {!crcFlag && <div className="search-item">
                        <label className="ui-label">与津石是否有合作</label>
                        <Select
                            allowClear={true}
                            style={{ width: 80 }}
                            onChange={(value) => this.handleSelectChange(value, 'isCooperation')}
                            value={isCooperation}
                            placeholder="请选择"
                        >
                            <Option value="1">是</Option>
                            <Option value="0">否</Option>
                        </Select>
                    </div>}
                    {!crcFlag && <div className="search-item">
                        <label htmlFor="" className="ui-label">业务线</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            value={lineOfBusiness}
                            onChange={value => this.handleSelectChange(value, 'lineOfBusiness')}
                        >
                            {businessOption}
                        </Select>
                    </div>}
                    {!crcFlag && <div className="search-item">
                        <label htmlFor="" className="ui-label">执行业务线二级分类</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            disabled={!lineOfBusiness}
                            value={searchParams.secondLineName}
                            onChange={value => this.handleSelectChange(value, 'secondLineName')}
                        >
                            {secondLineOption}
                        </Select>
                    </div>}
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">是否要求签署CRC协议</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            value={searchParams.signCrcAgreement}
                            onChange={value => this.handleSelectChange(value, 'signCrcAgreement')}
                        >
                            <Option value={'必须签署'}>必须签署</Option>
                            <Option value={'不签CRC协议'}>不签CRC协议</Option>
                            <Option value={'无相关要求'}>无相关要求</Option>
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">是否需要派遣函</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            value={searchParams.letter}
                            onChange={value => this.handleSelectChange(value, 'letter')}
                        >
                            <Option value={'需要'}>需要</Option>
                            <Option value={'不需要'}>不需要</Option>
                            <Option value={'无要求'}>无要求</Option>
                            <Option value={'其他'}>其他</Option>
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">是否有CRC协议模板</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            value={searchParams.crcAgreementModel}
                            onChange={value => this.handleSelectChange(value, 'crcAgreementModel')}
                        >
                            <Option value={'有模版'}>有模版</Option>
                            <Option value={'无模版'}>无模版</Option>
                            <Option value={'对模板没要求'}>对模板没要求</Option>
                            <Option value={'其他'}>其他</Option>
                        </Select>
                    </div>
                </div>
                <div className="search-bar flex-end">
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>搜索</Button>
                        { showExportButton && <Button type="primary" onClick={() => this.props.export(searchParams)}>导出</Button> }
                        <Button
                            type="primary"
                            style={{ background: '#62cf96', border: '1px solid #00a854' }}
                            onClick={() => location.href = `./#/SsuLog`}
                        >SSU日志</Button>
                        <Button type="primary" onClick={this.reset}>重置</Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/hospital/hospitalInfo/Filter.js